import React from 'react';
import { Mail, Github, Linkedin, ChevronDown } from 'lucide-react';

export default function Hero() {
    const scrollToAbout = () => {
        document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section id="home" className="min-h-screen flex flex-col justify-center items-center px-6 text-center pt-20">
            <div className="max-w-4xl space-y-8 animate-fade-in text-charcoal">
                <h2 className="text-xl md:text-2xl font-serif italic text-earth-brown">
                    Hello, I'm
                </h2>
                <h1 className="text-5xl md:text-8xl font-serif font-bold tracking-tight">
                    Sri Ram Reddy <br className="hidden md:block" /> Lankireddy
                </h1>
                <p className="text-lg md:text-xl text-charcoal/70 max-w-2xl mx-auto font-light leading-relaxed">
                    Full Stack Developer & Machine Learning Enthusiast building scalable applications and deploying real-world AI solutions.
                </p>

                <div className="flex gap-6 justify-center pt-8">
                    <a href="mailto:sriram.lankireddy@gmail.com" className="group flex items-center gap-2 border-b border-charcoal pb-1 hover:text-clay hover:border-clay transition-all">
                        <Mail size={18} />
                        <span>Email Me</span>
                    </a>
                    <a href="https://github.com/sriram9573" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-2 border-b border-charcoal pb-1 hover:text-clay hover:border-clay transition-all">
                        <Github size={18} />
                        <span>GitHub</span>
                    </a>
                    <a href="https://www.linkedin.com/in/sriram-lankireddy" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-2 border-b border-charcoal pb-1 hover:text-clay hover:border-clay transition-all">
                        <Linkedin size={18} />
                        <span>LinkedIn</span>
                    </a>
                </div>
            </div>

            <button
                onClick={scrollToAbout}
                className="absolute bottom-12 animate-bounce text-charcoal/50 hover:text-earth-brown transition-colors"
            >
                <ChevronDown size={32} />
            </button>
        </section>
    );
}
